module.exports = __webpack_public_path__ + "img/graphs-mobile-2.6e60c717.svg";